import {Component} from 'react'
import PropTypes from 'prop-types'

import 'react-phone-number-input/style.css'
import PhoneInput, {formatPhoneNumber, isValidPhoneNumber} from 'react-phone-number-input'
import flags from 'react-phone-number-input/flags'

import './phoneForm.scss'

export default class PhoneEditForm extends Component {
  constructor(props) {
    super(props)

    this.state = {mode: props.mode}
    this.onChange = this.onChange.bind(this)
    this.updateMode = this.updateMode.bind(this)
  }

  onChange(value = '') {
    const isValid = isValidPhoneNumber(value)
    const nationalNumber = formatPhoneNumber(value)
    this.props.setFormValue(isValid, nationalNumber, value)
  }

  updateMode(event) {
    const mode = event.target.value
    this.props.setMode(mode)
  }

  render() {
    const textId = `${this.props.radioName}-text`
    const voiceId = `${this.props.radioName}-voice`

    return (
      <div className={`phone-form ${this.props.variant === 'wizard' ? 'phone-form-wizard' : ''}`.trim()}>
        <div className={`field-group ${this.props.variant === 'wizard' ? 'phone-form-section' : ''}`.trim()}>
          <div className='phone-number-label-and-input-container'>
            <div className='form-label'>{this.props.numberLabel}</div>
            <div className='phone-number-input-container'>
              <PhoneInput
                className='phone-number-container'
                numberInputProps={{
                  className: 'phone-number',
                  placeholder: this.props.inputPlaceholder
                }}
                autoFocus={this.props.autoFocus}
                value={this.props.number}
                onChange={this.onChange}
                defaultCountry='US'
                flags={flags}
                limitMaxLength={true}
                initialValueFormat='national'
              />
              <span className='error'>{this.props.error}</span>
            </div>
          </div>
        </div>
        {
          this.props.showDeliveryOptions &&
            <div className={`field-group ${this.props.variant === 'wizard' ? 'phone-form-section' : ''}`.trim()}>
              <div className='delivery-options'>
                <div className='form-label'>{this.props.deliveryLabel}</div>
                <div className='delivery-options-container'>
                  <div className={`alternate-delivery-option ${this.props.variant === 'wizard' ? 'alternate-delivery-option-wizard' : ''}`.trim()}>
                    <input
                      checked={this.props.mode === 'text'}
                      className='tfa-radio-btn'
                      id={textId}
                      name={this.props.radioName}
                      onChange={this.updateMode}
                      type='radio'
                      value='text'
                    />
                    <label htmlFor={textId}>
                      <span className='alternate-delivery-option-label'>{this.props.textOptionLabel}</span>
                      {
                        this.props.textOptionDescription &&
                          <span className='alternate-delivery-option-description'>{this.props.textOptionDescription}</span>
                      }
                    </label>
                  </div>
                  <div className={`alternate-delivery-option ${this.props.variant === 'wizard' ? 'alternate-delivery-option-wizard' : ''}`.trim()}>
                    <input
                      checked={this.props.mode === 'voice'}
                      className='tfa-radio-btn'
                      id={voiceId}
                      name={this.props.radioName}
                      onChange={this.updateMode}
                      type='radio'
                      value='voice'
                    />
                    <label htmlFor={voiceId}>
                      <span className='alternate-delivery-option-label'>{this.props.voiceOptionLabel}</span>
                      {
                        this.props.voiceOptionDescription &&
                          <span className='alternate-delivery-option-description'>{this.props.voiceOptionDescription}</span>
                      }
                    </label>
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
    )
  }
}

PhoneEditForm.propTypes = {
  autoFocus: PropTypes.bool,
  deliveryLabel: PropTypes.string,
  number: PropTypes.string,
  numberLabel: PropTypes.string,
  mode: PropTypes.string,
  error: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  radioName: PropTypes.string,
  setFormValue: PropTypes.func,
  setMode: PropTypes.func,
  showDeliveryOptions: PropTypes.bool,
  textOptionDescription: PropTypes.string,
  textOptionLabel: PropTypes.string,
  variant: PropTypes.string,
  voiceOptionDescription: PropTypes.string,
  voiceOptionLabel: PropTypes.string
}

PhoneEditForm.defaultProps = {
  autoFocus: true,
  deliveryLabel: 'How should we send code?',
  error: '',
  inputPlaceholder: '',
  mode: 'text',
  number: '',
  numberLabel: 'Phone number:',
  radioName: 'message-mode',
  setFormValue: null,
  setMode: null,
  showDeliveryOptions: true,
  textOptionDescription: '',
  textOptionLabel: 'Text Message',
  variant: 'default',
  voiceOptionDescription: '',
  voiceOptionLabel: 'Phone call (Voice)'
}
